import {
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { makeStyles, Snackbar, TextField } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import {
  removeMarker,
  updateMarker,
} from "../../../../../../../store/actions/creator/analysis";
import UtilService from "../../../../../../../helper/service";
import { Alert } from "@material-ui/lab";
import EditNoteItem from "./editNoteItem";
import { fetchSessionMarker, updateSettings } from "../../../../../../../store/actions/creator/analysis";

const useStyles = makeStyles(() => ({
  commentRoot: {
    display: "flex",
    width: "100%",
    minHeight: 400,
    position: "relative",
  },

  container: {
    minWidth: 800,
  },
  title: {
    minWidth: 100,
    background: "#fff",
    padding: "9px 12px",
    borderRadius: 12,
    borderTopLeftRadius: 0,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    color: "#0179EE",
    fontFamily: "roboto-regular",
    fontSize: 12,
    cursor: "context-menu",
  },
  pdfTitle: {
    minWidth: 100,
    background: "#fff",
    padding: "9px 12px",
    borderRadius: 12,
    borderTopLeftRadius: 0,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    color: "#0179EE",
    fontFamily: "roboto-regular",
    fontSize: 12,
    cursor: "context-menu",
  },
  textBlack: {
    color: "#323232",
  },

  textEllipsis: {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    // WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    overflowWrap: "break-word",
  },
  drag_title: {
    minWidth: 100,
    padding: "4px 10px",
    borderRadius: 12,
    borderTopLeftRadius: 0,
    color: "#0179EE",
    fontFamily: "roboto-regular",
    fontSize: 12,
    marginLeft: -4,
  },
  box: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: "#fff",
    padding: 4,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  pdfBox: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: "#fff",
    padding: 4,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  hidden: {
    width: 30,
    height: 5,
    background: "#fff",
    position: "absolute",
    left: 0,
    marginTop: -3,
  },
  resizable: {
    // width: 16,
    position: "relative",
    top: 0,
    // border: "solid blue 1px",
  },
  bar: {
    width: "100%",
    height: 24,
    zIndex: -1,
    position: "absolute",
    background: "#e5f1fe",
  },
  times: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    fontSize: 12,
    fontFamily: "roboto-bold",
    marginBottom: -15,
  },
  iconRBox: {
    padding: 5,
    display: "flex",
    justifyContent: "flex-start",
    marginTop: -25,
  },
  iconLBox: {
    padding: 5,
    display: "flex",
    justifyContent: "flex-end",
    marginTop: -18,
    cursor: "pointer",
  },
  description: {
    padding: "6px 0",
    background: "#fff",
    paddingBottom: 18,
    boxShadow: "0 3px 4px rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  textField: {
    "& .MuiInputBase-root": {
      color: "#0179EE",
      fontFamily: "roboto-regular",
      fontSize: 12,
      marginTop: -4,
      background: "#e5f1fe",
      padding: "5px",
    },
  },
  pencil: {
    position: "absolute",
    zIndex: 100,
    cursor: "pointer",
  },

  iconDone: {
    position: "absolute",
    zIndex: 100,
    cursor: "pointer",
    color: "#1db859",
    margin: "-2px 0 0 1px",
  },
}));

function MarkerSection(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    markers,
    currentSession,
    analyseStart,
    analyseEnd,
    cliped,
    settings
  } = useSelector((state: any) => state.analysis);
  const { session_code, session_type, session_status } = currentSession;
  const {
    addNoteX,
    addNoteY,
    editDone,
    annotation,
    liveMode,
    pencil,
    lineStep,
  } = props;
  const { graphZoom, pdfLoading } = settings;

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const start_at = Math.floor(analyseStart);

  const DRAGGABLE_HEIGHT = 90;

  const [editIndex, setEditIndex] = useState(-1);
  const [comments, setComments] = useState<any[]>([]);
  const [commentsPosition, setCommentsPosition] = useState<any>([]);
  const [startPoint, setStartPoint] = useState(0);
  const [endPoint, setEndPoint] = useState(0);
  const [curDragX, setCurDragX] = useState(0);
  const [curDraggingId, setCurDraggingId] = useState(-1);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [editNoteContainerWidth, setEditNoteContainerWidth] = useState(0);
  const [newMarkerId, setNewMarkerId] = useState(-1);

  const start = cliped ? cliped.start_clip - (session_type === 'ASYNC' ? 0 : analyseStart) : 0;
  const end = cliped ? cliped.end_clip - cliped.start_clip - 1 : analyseEnd - analyseStart - 1;
  const NOTE_MIN_WIDTH = 100;

  useLayoutEffect(() => {
    window.addEventListener("resize", updateEditNoteWidth);
    // return () => {
    //     window.removeEventListener('resize', updateEditNoteWidth);
    // };
  });

  useEffect(() => {
    updateEditNoteWidth();
  }, [graphZoom]);

  useEffect(() => {
    setComments(markers.filter((item: any) => item.marker_type !== 1 && item.start_marker_at !== "0"));
  }, [markers]);

  useEffect(() => {
    if (pencil) {
      onEditDone(true);
    }
  }, [pencil]);

  useEffect(() => {
    if (addNoteX !== -1 && addNoteY !== -1) {
      const marker_type = ((session_status === 'LIVE' && session_type === 'MODERATED') ? 1 : 2) + Math.min(Math.max(Math.round(addNoteY / 90), 0), 6);
      const marker_id = UtilService.getCurrentTimeMills();
      const newNote = {
        marker_title: liveMode ? annotation : "",
        marker_id,
        marker_type,
        start_marker_at: liveMode ? addNoteX : start_at + start + Math.floor((addNoteX / lineStep) * Math.pow(graphZoom, 2)),
        end_marker_at: liveMode ? addNoteX + 5 : start_at + start + Math.floor((addNoteX / lineStep) * Math.pow(graphZoom, 2)) + 5,
        marker_user_id: loginUserData.user_id,
        can_save: true,
      };

      setComments((_comments) => [..._comments, newNote]);
      setNewMarkerId(marker_id);

      setCommentsPosition((_commentsPosition: any) => [..._commentsPosition, {
        id: marker_id,
        dragX: 0,
        dragY: 0,
        resizeLeft: 0,
        resizeRight: 0,
        marker_title: "",
      }]);
    }
  }, [addNoteX, addNoteY]);

  useEffect(() => {
    if (newMarkerId !== -1) {
      const newNote = comments.find((item: any) => item.marker_id === newMarkerId);
      if (comments.length > 0 && newNote)
        editNote(newNote, !liveMode);
    }
  }, [comments, newMarkerId, liveMode]);

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onEditDone(false);
    }
  };

  const updateEditNoteWidth = () => {
    const timer1 = setTimeout(() => {
      const commentContainer = document.getElementById("comment_container");
      if (!commentContainer) return;

      setEditNoteContainerWidth(commentContainer.offsetWidth);
    }, 100);
    return () => {
      clearTimeout(timer1);
    };
  };

  const getNoteWidth = (item: any) => {
    let noteWidth =
      ((item.end_marker_at - item.start_marker_at) * lineStep) /
      Math.pow(graphZoom, 2);
    const noteStartPosition = getEditStartXPosition(item);
    const offset = noteStartPosition + noteWidth - editNoteContainerWidth;
    if (offset > 0) noteWidth -= offset;

    return Math.max(noteWidth, NOTE_MIN_WIDTH);
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const editNote = (item: any, editable: boolean) => {
    if (editable) setEditIndex(item.marker_id);
    setStartPoint(Number(item.start_marker_at) - start_at);
    setEndPoint(Number(item.end_marker_at) - start_at);
    if (!editable) {
      onEditDone(true);
    }
  };

  const onEditDone = async (isNew: boolean) => {
    const comment = comments.find((item: any) => isNew ? item.marker_id === newMarkerId : item.marker_id === editIndex);
    setEditIndex(-1);
    setNewMarkerId(-1);
    dispatch(updateSettings('addNoteX', -1));
    dispatch(updateSettings('addNoteY', -1));
    if (editDone) editDone();
    if (!comment) return false;

    onSaveComment(comment);

  };

  const onRemoveMarker = (id: string) => {
    setComments(comments.filter((item: any) => item.marker_id !== id));
    setCommentsPosition(commentsPosition.filter((item: any) => item.id !== id));

    dispatch(removeMarker(apolloClient.client, { marker_id: parseInt(id) }));
    setTimeout(() => dispatch(fetchSessionMarker(apolloClient.client, { session_code })), 1000)
  };

  const onEditNote = (text: string, id: any) => {
    setComments(comments.map((comment: any) => comment.marker_id === id ? { ...comment, marker_title: text } : comment));
  };

  const onHandleDrag = (e: any, id: number) => {
    const ids = commentsPosition.map((item: any) => item.id);
    const defaultPosition = commentsPosition.map((position: any) => {
      if (position.id === id) {
        const dragX = position.dragX + e.movementX / lineStep / Math.pow(/*graphZoom*/ 1, 2);
        setCurDragX(dragX);
      }
      return position.id === id ?
        {
          ...position,
          dragX: position.dragX + e.movementX / lineStep / Math.pow(/*graphZoom*/ 1, 2),
          dragY: position.dragY + e.movementY
        } : position;
    });
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        dragX: e.movementX / lineStep / Math.pow(1, 2),
        dragY: e.movementY,
        resizeLeft: 0,
        resizeRight: 0,
        marker_title: "",
      });
    }
    setCommentsPosition(defaultPosition);
    setCurDraggingId(id);
  };

  const onDragStop = (id: number) => {

    setCurDragX(0);
    setCurDraggingId(-1);

    const currentCommentPosition = commentsPosition.find(
      (item: any) => Number(item.id) === id
    );

    if (Boolean(currentCommentPosition)) {
      const currentComment = comments.find((item: any) => Number(item.marker_id) === id);
      if (Boolean(currentComment)) {
        currentComment.start_marker_at =
          Number(currentComment.start_marker_at) +
          Math.floor(currentCommentPosition.dragX * Math.pow(graphZoom, 2));
        currentComment.end_marker_at =
          Number(currentComment.end_marker_at) +
          Math.floor(currentCommentPosition.dragX * Math.pow(graphZoom, 2));

        let offsetX = Number(currentComment.start_marker_at) - start_at - start;
        if (offsetX < 0) {
          currentComment.start_marker_at =
            Number(currentComment.start_marker_at) - offsetX;
          currentComment.end_marker_at =
            Number(currentComment.end_marker_at) - offsetX;
        }

        offsetX =
          Number(currentComment.start_marker_at) -
          (cliped ? (session_type === 'ASYNC' ? cliped.end_clip + analyseStart : cliped.end_clip) : analyseEnd);
        if (offsetX > 0) {
          currentComment.start_marker_at =
            Number(currentComment.start_marker_at) - offsetX - 2;
          currentComment.end_marker_at =
            Number(currentComment.end_marker_at) - offsetX - 2;
        }

        const marker_type =
          currentComment.marker_type +
          Math.round(currentCommentPosition.dragY / DRAGGABLE_HEIGHT);
        currentComment.marker_type = Math.min(Math.max(2, marker_type), 8);

        onSaveComment(currentComment);
      }
      setCommentsPosition(
        commentsPosition.map((item: any) =>
          Number(item.id) === id ? { ...item, dragX: 0, dragY: 0 } : item
        )
      );
    }
  };

  const onResizeLeftStop = ({ }, id: number) => {
    const currentCommentPosition = commentsPosition.find(
      (item: any) => Number(item.id) === id
    );
    if (Boolean(currentCommentPosition)) {
      const currentComment = comments.find((item: any) => Number(item.marker_id) === id);
      if (Boolean(currentComment)) {
        currentComment.start_marker_at =
          Number(currentComment.start_marker_at) +
          Math.floor(
            currentCommentPosition.resizeLeft * Math.pow(graphZoom, 2)
          );

        if (currentComment.start_marker_at <= start_at + start)
          currentComment.start_marker_at = start_at + start;

        if (currentComment.end_marker_at >= (cliped ? cliped.start_clip : start_at) + end)
          currentComment.end_marker_at = (cliped ? cliped.start_clip : start_at) + end;

        setComments(
          comments.map((comment: any) =>
            Number(comment.marker_id) === id ? currentComment : comment
          )
        );
      }
      setCommentsPosition(
        commentsPosition.map((item: any) =>
          Number(item.id) === id ? { ...item, resizeLeft: 0, resizeRight: 0 } : item
        )
      );
    }
  };

  const onResizeLeft = (e: any, id: number) => {
    let startPosition = startPoint + (e.movementX / lineStep) * Math.pow(graphZoom, 2);
    startPosition = Math.max(startPosition, start);
    const moveX = ((startPosition - startPoint) / Math.pow(graphZoom, 2)) * lineStep;
    setStartPoint(startPosition);

    const ids = commentsPosition.map((item: any) => item.id);
    const defaultPosition = commentsPosition.map((position: any) =>
      Number(position.id) === id ? { ...position, resizeLeft: position.resizeLeft + moveX / lineStep / Math.pow(1, 2) } : position
    );
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        resizeLeft: moveX / lineStep / Math.pow(1, 2),
        dragX: 0,
        marker_title: "",
      });
    }
    setCommentsPosition(defaultPosition);
  };


  const onResizeRightStop = ({ }, id: number) => {
    const currentCommentPosition = commentsPosition.find(
      (item: any) => Number(item.id) === id
    );

    if (Boolean(currentCommentPosition)) {
      const currentComment = comments.find((item: any) => Number(item.marker_id) === id);
      if (Boolean(currentComment)) {

        currentComment.end_marker_at =
          Number(currentComment.end_marker_at) +
          Math.floor(
            currentCommentPosition.resizeRight * Math.pow(graphZoom, 2)
          )

        if (currentComment.start_marker_at <= start_at + start)
          currentComment.start_marker_at = start_at + start;

        if ((currentComment.end_marker_at >= (cliped ? cliped.start_clip : start_at) + end))
          currentComment.end_marker_at = (cliped ? cliped.start_clip : start_at) + end;

        setComments(
          comments.map((comment: any) =>
            Number(comment.marker_id) === id ? currentComment : comment
          )
        );
      }
      setCommentsPosition(
        commentsPosition.map((item: any) =>
          Number(item.id) === id ? { ...item, resizeLeft: 0, resizeRight: 0 } : item
        )
      );
    }
  };

  const onResizeRight = (e: any, id: number) => {
    const endPosition =
      endPoint + (e.movementX / lineStep) * Math.pow(graphZoom, 2);

    // endPosition = Math.min(endPosition, end);
    const moveX = ((endPosition - endPoint) / Math.pow(graphZoom, 2)) * lineStep;
    setEndPoint(endPosition);



    const ids = commentsPosition.map((item: any) => item.id);
    const defaultPosition = commentsPosition.map((position: any) =>
      Number(position.id) === id
        ? {
          ...position,
          resizeRight:
            position.resizeRight +
            moveX / lineStep / Math.pow(1, 2),
        }
        : position
    );
    if (!ids.includes(id)) {
      defaultPosition.push({
        id,
        resizeRight: moveX / lineStep / Math.pow(1, 2),
        dragX: 0,
        marker_title: "",
      });
    }
    setCommentsPosition(defaultPosition);
  };

  const onSaveComment = async (comment: any) => {
    if (!comment) return;

    if (comment.can_save === false) {
      return;
    }

    if (comment.can_save === true) {
      comment.can_save = false;
    }

    setComments(
      comments.map((item: any) =>
        item.marker_id === comment.marker_id ? comment : item
      )
    );

    if (!comment.marker_type) {
      dispatch(fetchSessionMarker(apolloClient.client, { session_code }))
      return false
    }

    const request: any = {
      session_code,
      marker_title: comment.marker_title,
      marker_start_at: Math.floor(Number(comment.start_marker_at)).toString(),
      marker_end_at: Math.floor(Number(comment.end_marker_at)).toString(),
      marker_type: comment.marker_type,
      user_id: parseInt(loginUserData.user_id),
      marker_id: parseInt(comment.marker_id),
    };

    if (parseInt(comment.marker_id) > 1000000) {
      delete request.marker_id;
    }

    dispatch(
      updateMarker(apolloClient.client, request, (res: any) => {
        if (comment.can_save === false) {
          const old_marker_id = comment.marker_id;
          if (res.updateMarker.data) {
            comment.marker_id = res.updateMarker.data.marker_id;
          }

          delete comment.can_save;

          setComments(
            comments.map((item: any) =>
              Number(item.marker_id) === old_marker_id ? comment : item
            )
          );
        }
      })
    );

    setTimeout(() => dispatch(fetchSessionMarker(apolloClient.client, { session_code })), 1000)

  };

  const getStartXPosition = (item: any) => {
    const xPosition = getEditStartXPosition(item);
    return xPosition;
  };

  const getEditStartXPosition = (item: any) => {
    const xPosition =
      ((parseInt(item.start_marker_at) - start_at - start) /
        Math.pow(graphZoom, 2)) *
      lineStep;
    return xPosition;
  };

  const getEndXPosition = (item: any) => {
    const xPosition =
      ((parseInt(item.end_marker_at) - start_at - start) /
        Math.pow(graphZoom, 2)) *
      lineStep;
    return xPosition;
  };

  const getEditEndXPosition = (item: any) => {
    const xStartPosition = getEditStartXPosition(item);
    let xEndPosition = getEndXPosition(item);
    const width = xEndPosition - xStartPosition;
    if (width < NOTE_MIN_WIDTH) {
      xEndPosition += NOTE_MIN_WIDTH - width;
    }

    return xEndPosition;
  };

  const dragElement = (item: any, index: number) => <div style={{ position: "absolute", width: 0 }}>
    {editIndex !== item.marker_id && (
      <>
        <div className={pdfLoading ? classes.pdfBox : classes.box}>
          <img
            src={
              "/assets/icons/liveanalysis/pencil-ruler-grid-black.svg"
            }
            alt={"img"}
            onClick={() => {
              if (item.can_save === false) {
                setShownSnackAlert(true);
              } else {
                editNote(item, true);
              }
            }}
            className={classes.pencil}
          />
        </div>
        <div className={classes.hidden}></div>
      </>
    )}

    <div>
      <div className="handle">
        <div>
          {editIndex === item.marker_id && (
            <>
              <EditNoteItem
                // width={((item.end_marker_at - item.start_marker_at) / Math.pow(graphZoom, 2) + UtilService.getResizeEndPoint(commentsPosition, item)) * lineStep}
                onResizeLeft={(e: any) =>
                  onResizeLeft(e, Number(item.marker_id))
                }
                onResizeLeftStop={(e: any) =>
                  onResizeLeftStop(e, Number(item.marker_id))
                }
                onResizeRight={(e: any) => {
                  onResizeRight(e, Number(item.marker_id))
                }}
                onResizeRightStop={(e: any) =>
                  onResizeRightStop(e, Number(item.marker_id))
                }
                wrapperClass1={clsx(classes.resizable)}
                wrapperClass2={clsx(classes.resizable)}
                editNoteContainerWidth={
                  editNoteContainerWidth + NOTE_MIN_WIDTH
                }
                noteMinWidth={NOTE_MIN_WIDTH}
                startXPosition={getStartXPosition(item)}
                endXPosition={
                  editNoteContainerWidth +
                  NOTE_MIN_WIDTH -
                  getEditEndXPosition(item)
                }
                style={{
                  // border: '1px solid red',
                  position: "absolute",
                  left: `${-getStartXPosition(item)}px`,
                  top: `${-(index % 3) * 90}px`,
                  width: `${editNoteContainerWidth + NOTE_MIN_WIDTH
                    }px`,
                  height: "300px",
                  paddingTop: `${(index % 3) * 90}px`,
                  marginLeft: 0,
                  display: "flex",
                }}
              >
                {/*<div className={classes.bar}/>*/}

                {editIndex === item.marker_id && (
                  <>
                    <div className={pdfLoading ? classes.pdfBox : classes.box}>
                      <DoneIcon
                        onClick={() => {
                          onEditDone(false);
                        }}
                        fontSize={"small"}
                        className={classes.iconDone}
                      />
                    </div>
                  </>
                )}

                <div className={classes.description}>
                  <TextField
                    inputRef={(input) => {
                      input && input.focus();
                    }}
                    onFocus={(e) =>
                      e.currentTarget.setSelectionRange(
                        e.currentTarget.value.length,
                        e.currentTarget.value.length
                      )
                    }
                    defaultValue={item.marker_title}
                    value={item.marker_title}
                    onChange={(e) =>
                      onEditNote(e.target.value, item.marker_id)
                    }
                    onKeyPress={(e) => onKeyPress(e)}
                    fullWidth
                    multiline
                    InputProps={{
                      disableUnderline: true,
                    }}
                    className={classes.textField}
                    placeholder={"Type something…"}
                  />
                </div>

                <div className={classes.iconLBox}>
                  <img
                    src={
                      "/assets/icons/liveanalysis/trash-icon.svg"
                    }
                    alt={"trash"}
                    onClick={() => onRemoveMarker(item.marker_id)}
                  />
                </div>

                <div className={classes.times}>
                  <span>
                    {UtilService.getTimeLabel(startPoint, 1, 0)}
                  </span>
                  <span>
                    {UtilService.getTimeLabel(endPoint, 1, 0)}
                  </span>
                </div>
              </EditNoteItem>
            </>
          )}

          {editIndex !== item.marker_id && (
            <div
              className={clsx(pdfLoading ? classes.pdfTitle : classes.title, classes.textBlack)}
              style={{
                width: getNoteWidth(item),
                cursor: "move",
              }}
            >
              <div className={classes.textEllipsis}>
                <span>{item.marker_title}</span>
              </div>
            </div>
          )}
        </div>

        {curDraggingId === Number(item.marker_id) && (
          <div
            className={clsx(classes.times, classes.drag_title)}
            style={{
              width:
                ((item.end_marker_at - item.start_marker_at) /
                  Math.pow(graphZoom, 2)) *
                lineStep,
            }}
          >
            <span className={classes.textBlack}>
              {UtilService.getStartTimeLabel(
                item.start_marker_at -
                start_at +
                curDragX * Math.pow(graphZoom, 2),
                1,
                0
              )}
            </span>
            <span className={classes.textBlack}>
              {UtilService.getEndTimeLabel(
                item.start_marker_at -
                start_at +
                curDragX * Math.pow(graphZoom, 2),
                item.end_marker_at -
                start_at +
                curDragX * Math.pow(graphZoom, 2),
                1,
                0
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  </div>

  return (
    <div style={{ position: "relative" }}>
      <div
        className={classes.commentRoot}
        id={"comment_container"}
        style={{ height: DRAGGABLE_HEIGHT * 7 }}
      >
        {comments
          .filter(
            (item: any) =>
              liveMode ||
              (item.start_marker_at - start_at - start >= 0 && item.end_marker_at - start_at - start - end <= 1)
          )
          .map((item: any, index: number) => (
            <Draggable
              key={item.marker_id}
              bounds="parent"
              axis="both"
              position={{
                x: getStartXPosition(item),
                y: (item.marker_type - 2) * DRAGGABLE_HEIGHT,
              }}
              disabled={editIndex === item.marker_id}
              onDrag={(e) => onHandleDrag(e, Number(item.marker_id))}
              onStop={() => onDragStop(Number(item.marker_id))}
              {...{children: dragElement(item, index)}}
            />
          ))}

        <Snackbar
          open={isShownSnackAlert}
          autoHideDuration={1400}
          onClose={hideSnackAlert}
        >
          <Alert onClose={hideSnackAlert} severity="error">
            Please wait until save the marker...
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default MarkerSection;
